export const setDevice = (({commit}, device) => {
    commit('SET_DEVICE', device)
})
export const setDevicePixel = (({commit}, pixel) => {
    commit('SET_DEVICE_PIXEL', pixel)
})